import gql from 'graphql-tag'

export const fetchSubmittedOrderDetailsQuery = gql`
  query ($orderNumber: [String]) {
    customer {
      orders(filter: { number: { in: $orderNumber } }) {
        items {
          order_number
          id
          created_at
          grand_total
          status
          cart_prices {
            grand_total_price
            grand_total_price_with_vat
            grand_total_excise_duty
            grand_total_discount
            grand_total_vat
            grand_total_final
          }
          items {
            product_sku
            quantity_ordered
            material_type
          }

          additional_data {
            empty_order_number 
            delivery_date
            delivery_message
            empty_return
            ship_to_name
            ship_to_id
            total_empties_deposit
            total_your_price
            customer_order_number
            payment_method
            total_your_price_tax
            total_your_price_empty_deposit
            type_of_transport
            sap_id
            beer_order
          }

          shipping_address {
            firstname
            lastname
            middlename
            region
            region_id
            country_code
            street
            company
            telephone
            fax
            postcode
            city
            prefix
            suffix
            vat_id
          }
          billing_address {
            firstname
            lastname
            middlename
            region
            region_id
            country_code
          }
        }
      }
    }
  }
`
